<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            订单列表
        </div>
        <div style="padding: 22px;">
            <div>
                <el-row style="float:right">
                    <div>
                        <el-form :inline="true" class="demo-form-inline">
                            
                            <el-form-item>
                                <el-input placeholder="请输入姓名" v-model="name" clearable style="width:200px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="请输入手机号" v-model="phone" clearable style="width:200px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="goodsType" clearable placeholder="请选择商品类型" style="width:200px;" @change="getGoodsType">
                                    <el-option
                                            v-for="item in goodsTypeValue"
                                            :key="item[0]"
                                            :label="item[1]"
                                            :value="item[0]">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                                        
                            <el-form-item>
                                <el-select v-model="status"   placeholder="请选择订单状态" style="width:200px;">
                                    <el-option-group
                                        v-for="group in statusValue"
                                        :key="group.label"
                                        :label="group.label">
                                        <el-option
                                            v-for="item in group.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <Daterange :startTime="startTime" :endTime="endTime" @dataChange='dataChange'></Daterange>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索 </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>
            <div>
                <template>

                    <el-table
                            :data="tableData"
                            :height="th"
                            v-loading="loading"
                            border style="width: 100%;">
                        <el-table-column prop="serialNumber" label="订单流水号" width="300"></el-table-column>
                        <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>
                        <el-table-column prop="user.phone" label="手机号" width="150"></el-table-column>
                        <el-table-column prop="orderGoods.goodsName" label="商品名称"
                                         width="150"></el-table-column>
                        <el-table-column prop="orderGoods.goodsPrice" label="单价(元)"
                                         width="105"></el-table-column>
                        <el-table-column prop="orderGoods.number" label="购买数量"></el-table-column>
                        <el-table-column prop="price" label="总价(元)" width="105"></el-table-column>
                        <el-table-column
                          prop="status"
                          :formatter="statuss"
                          label="订单状态">
                        </el-table-column>
                        <el-table-column prop="serve.name" label="服务人员" width="85"></el-table-column>
                        <!-- <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200"
                                         label="预约时间"></el-table-column> -->
                        <el-table-column prop="createTime" :formatter="timefilter" width="200"
                                         label="下单时间"></el-table-column>
                        <el-table-column prop="orderServe.startTime" :formatter="getSETime" width="200"
                                         label="服务开始时间"></el-table-column>
                        <el-table-column prop="orderServe.endTime" :formatter="getSETime" width="200"
                                         label="服务结束时间"></el-table-column>
                        <el-table-column
                                prop="orderType"
                                :formatter="statusTitle"
                                label="订单类型" width="150">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="openQr(scope.row)">订单二维码</el-button>
<!--                              <el-button type="primary" size="small" v-if="row.orderType===1"    >发货</el-button>-->
                                <!-- <el-button type="primary" size="small" :loading="loading"  @click="deleteOrder(scope.row)" >删除</el-button> -->
                            </template>
                        </el-table-column>


                    </el-table>

                    <el-dialog
                            title="二维码"
                            :visible.sync="OpenQrCode"
                            width="30%"
                            class="QRCode">
                        <div class="canvas-code" id="qrcode" ></div>
                    </el-dialog>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <el-dialog
            title="商品价格/库存"
            :visible.sync="showModalGoodsInfo"
            center
            top='30vh'
            width="600px" :close-on-click-modal='false'>
            <template>
                <el-table
                    :data="goodsPriceDTOList"
                    :span-method="arraySpanMethods"
                    border
                    height="350"
                    v-if="goodsPriceDTOList.length>0"
                    style="width: 100%">
                    <el-table-column
                        v-if="goodsPriceDTOList[0].goodsColorName"
                        prop="goodsColorName"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        v-if="goodsPriceDTOList[0].goodsSizeName"
                        prop="goodsSizeName"
                        label="尺寸">
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        label="单价（元）">
                    </el-table-column>
                    <el-table-column
                        prop="stock"
                        label="库存">
                    </el-table-column>
                </el-table>
            </template>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr, timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";
    import QRCode from "qrcodejs2";
    import Daterange from "@/components/Daterange";

    export default {
        name: "Role",
        data() {
            return {
                showModalGoodsInfo:false,
                statusValue:[{
                        label: '总状态',
                        options: [{
                            value: -1,
                            label: '全部状态'
                    }]
                    }],
                statusValue1:{
                    label: '社会化服务',
                    options: [{
                        value: 10,
                        label: '待付款'
                    }, {
                        value: 11,
                        label: '待接单'
                    }, {
                        value: 12,
                        label: '已接单'
                    }, {
                        value: 13,
                        label: '服务中'
                    }, {
                        value: 14,
                        label: '服务完成'
                    }, {
                        value: 15,
                        label: '交易取消'
                    }, {
                        value: 16,
                        label: '已评价'
                    }
                    ]
                },
                statusValue2:{
                    label: '普通商品',
                    options: [{
                        value: 0,
                        label: '待付款'
                    }, {
                        value: 1,
                        label: '待发货'
                    }, {
                        value: 2,
                        label: '待收货'
                    }, {
                        value: 3,
                        label: '交易成功'
                    }, {
                        value: 4,
                        label: '退款中'
                    }, {
                        value: 5,
                        label: '交易关闭'
                    }, {
                        value: 6,
                        label: '交易取消'
                    }, {
                        value: 7,
                        label: '已评价'
                    }]
                },
                status:-1,
                OpenQrCode: false,
                loading: false,
                showModalAdd: false,
                showModalEdit: false,
                tableData: [],
                goodsClassCode: '',
                name: '',
                phone: '',
                businessCode: '',
                datetimerangeValue: '',
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                imgUrl: this.$imgUrl,
                th: this.$store.state.tableHeight-15,
                goodsClassValue: [],
                orderCode:'',
                orderBusinessCode:'',
                zoneValue: [],
                goodsType:-1,
                startTime:'',
                endTime:'',
                goodsTypeValue:[[-1,'全部类型'],[1,'普通商品'],[2,'社会化服务']],
                goodsPriceDTOList:[]
            }
        },
        components:{
            Daterange
        },
        created() {
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight-15;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {
            init(){
                this.statusValue.push(this.statusValue1)
                this.statusValue.push(this.statusValue2)
                // var  a =timefilters(new Date()).slice(0,7)
                // this.endTime =timefilters(new Date(new Date(a)-1000 * 60 * 60 * 24)).slice(0,10);
                // this.startTime = timefilters(new Date(a).setMonth(new Date(a).getMonth() - 1)).slice(0,10);
                this.endTime=timefilters(new Date()).slice(0,10)
                this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24*30)).slice(0,10)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "GoodsClass/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.goodsClassValue = response.data.data;
                        } else if (response.data.error == 1) {
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            dataChange(val){
                this.startTime=val[0]
                this.endTime=val[1]
            },
            getZoneValue(val) {
                this.zoneCode = val
            },
            openQr(row){
                this.OpenQrCode=true;
                if(document.getElementById("qrcode")){
                    document.getElementById("qrcode").innerHTML = "";
                }
                this.$nextTick (function () {
                    this.qrcodeInit(row);
                })
            },
            //日期格式
            timefilter(row, column, cellValue) {
                if (cellValue) {
                    return timefilters(cellValue)
                }
            },
            getSETime(row, column, cellValue) {
                if (cellValue) {
                    var time = timefilters(cellValue);
                    if (time == '1970-01-01 08:00:00') {
                        return ''
                    } else {
                        return timefilters(cellValue)
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            deleteOrder(row){
                console.log(row.orderBusinessCode)
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "OrderBusiness/deleteOrder",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        orderBusinessCode:row.orderBusinessCode
                    }
                }).then((response) => {
                    console.log(response);
                    if (response.data.error == 0) {
                        this.loading=false;
                        this.getList();
                    } else if (response.data.error == 1) {
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getGoodsType(e){
                this.status=-1
                var index=this.statusValue.indexOf(this.statusValue2)
                var index1=this.statusValue.indexOf(this.statusValue1)
                if(index1==-1)this.statusValue.push(this.statusValue1)
                if(index==-1)this.statusValue.push(this.statusValue2)
                if(e==2){
                    var index2=this.statusValue.indexOf(this.statusValue2)
                    if(index2!=-1)this.statusValue.splice(index2,1)
                }else{
                    var index3=this.statusValue.indexOf(this.statusValue1)
                    if(index3!=-1)this.statusValue.splice(index3,1)
                }
            },



            getList() {
                // var goodsClassCode = '00000000-0000-0000-0000-000000000000';
                // if (this.goodsClassCode) {
                //     goodsClassCode = this.goodsClassCode
                // }
                console.log(this.startTime)
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "OrderBusiness/PageOrderForBusiness",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        // goodsClassCode: goodsClassCode,
                        goodsType: this.goodsType,
                        startTime: this.startTime,
                        endTime:  this.endTime,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                        name:this.name,
                        phone:this.phone,
                        status:this.status
                    }
                }).then((response) => {
                    this.loading=false;
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.orderCode=this.tableData.orderCode;
                    } else if (response.data.error == 1) {
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue) {
                return this.allStatus(cellValue, ["", '普通商品订单', '社会化服务订单', '政府购买服务订单']);
            },
            isSchedules(row, column, cellValue) {
                return this.allStatus(cellValue, ['否', '是']);
            },
            statuss(row, column, cellValue) {
                return this.allStatus(cellValue, ['待付款', '待发货', '待收货', '交易成功', '退款中', '交易关闭', '交易取消', '已评价', "", "", '待付款', '待接单', '已接单', '服务中', '服务完成', '交易取消', '已评价']);
            },
            allStatus(row, status) {
                for (var i in status) {
                    if (i == row) {
                        return status[i]
                    }
                }
                return "其它";
            },

            //  生成二维码
            qrcodeInit (row) {
                new QRCode('qrcode', {
                    width: 250,
                    height: 250,        // 高度
                    text:  row.orderBusinessCode,   // 二维码内容
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                })
            },

        }
    }
</script>

<style scoped>



    .QRCode{
       text-align: center;
        width: 1000px;
        margin-left: 400px;
        margin-top: 150px;
    }

</style>
